module.exports = __webpack_public_path__ + "img/farzana-christopher-13.22ef8390.jpg";